/**
 * Converts an ISO date string (e.g. "2025-08-31T00:00:00.000Z") to date-only "YYYY-MM-DD".
 * Returns the value unchanged if it's not an ISO date string.
 */
export const toDateOnlyString = (value) => {
    if (value == null || typeof value !== 'string') return value;
    const trimmed = value.trim();
    if (!/^\d{4}-\d{2}-\d{2}/.test(trimmed)) return value;
    try {
        const d = new Date(trimmed);
        if (Number.isNaN(d.getTime())) return value;
        return d.toISOString().split('T')[0];
    } catch {
        return value;
    }
};

/**
 * Returns a shallow copy of obj with any ISO date string values normalized to YYYY-MM-DD.
 * Used so payloads and blockState use date-only format for date fields.
 */
export const normalizeDatesInObject = (obj) => {
    if (obj == null || typeof obj !== 'object') return obj;
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}T/.test(value)) {
            result[key] = toDateOnlyString(value);
        } else {
            result[key] = value;
        }
    }
    return result;
};
